import $ from 'jquery'
import Behaviors from '../behaviors'
import FormSubmit from './formSubmit'

export default class cannabisPrescriptionSelectPharmacyModal {
    constructor (element) {
        this.$element = $(element)
        this.targetInputId = this.$element.data('targetInputId')
        this.$targetInput = $('body').find(`input#${this.targetInputId}`)

        this.$deliverySearchForm = this.$element.find('form#formDeliverySearch')
        this.$searchInput = this.$deliverySearchForm.find('input[name=search]')
        this.$deliverySearchForm.on('submit', this.handleSearchSubmit.bind(this))
        this.searchUrl = this.$deliverySearchForm.attr('action')

        this.$deliverySelectForm = this.$element.find('form#formDeliverySelect')
        this.$deliverySelectForm.on('submit', this.handleDeliverySelect.bind(this))

        this.$customPharmacyForm = this.$element.find('form#formNewCustomPharmacy')

        this.deliveryFormSubmit = new FormSubmit(this.$customPharmacyForm.get(0))
        this.deliveryFormSubmit.setPayloadHandler(this.newCustomPharmacyPayloadHandler.bind(this))

        this.$deliveryResultContainer = this.$element.find('.deliveryResultContainer')
        this.$searchResultContainer = this.$element.find('.searchResultContainer')
        this.$searchInput.on('change', this.handleSearchChange.bind(this))
        this.$searchInput.on('keyup', this.handleSearchChange.bind(this))
        this.lastSearchValue = ''
        this.searchXHR = null

        this.newCustomPharmacyButtonSelector = this.$element.data('newCustomPharmacyButtonSelector')
        this.newCustomPharmacyUiSelector = this.$element.data('newCustomPharmacyUiSelector')
        this.$deliveryTargetSelectUi = this.$element.find('.deliveryTargetSelectUi')
        this.$newCustomPharmacyUi = this.$element.find(this.newCustomPharmacyUiSelector)

        this.$newCustomPharmacyForm = this.$element.find('form#formNewCustomPharmacy')
        this.$customPharmacyCancelButton = this.$newCustomPharmacyUi.find('#button-custom-pharmacy-cancel')
        this.$customPharmacyCancelButton.on('click', this.handleCustomPharmacyCancelButton.bind(this))
        this.$modalFooter = this.$element.find('.modal-footer')

        this.$searchSpinner = this.$deliveryResultContainer.find('.loadingSpinner')

        this.$newCustomPharmacyUi.hide()
        this.addNewCustomPharmacyButtonListener()
    }

    newCustomPharmacyPayloadHandler (payload) {
        if (payload.hasOwnProperty('deliveryTarget')) {
            this.$targetInput.val(payload.deliveryTarget)
            this.$targetInput.trigger('change')
        }
    }

    addNewCustomPharmacyButtonListener () {
        const $button = this.$searchResultContainer.find(this.newCustomPharmacyButtonSelector)
        $button.on('click.cannabisPrescriptionSelectPharmacyModal', this.newCustomPharmacy.bind(this))
    }

    handleCustomPharmacyCancelButton (event) {
        event.preventDefault()
        this.closeCustomPharmacyUi()
    }

    newCustomPharmacy (event) {
        event.preventDefault()
        this.openCustomPharmacyUi()
    }

    openCustomPharmacyUi () {
        this.$deliveryTargetSelectUi.hide()
        this.$newCustomPharmacyUi.show()
        this.$modalFooter.hide()
    }

    closeCustomPharmacyUi () {
        this.$deliveryTargetSelectUi.show()
        this.$newCustomPharmacyUi.hide()
        this.$modalFooter.show()
    }

    handleSearchSubmit (event) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()

        const searchText = this.$searchInput.val().trim()
        this.search(searchText)
    }

    handleSearchChange (event) {
        const searchText = this.$searchInput.val().trim()
        if (searchText.length === 0 || searchText.length > 3) {
            if (this.lastSearchValue !== searchText) {
                this.$deliverySearchForm.trigger('submit')
            }
        }
    }

    search (value) {
        if (this.lastSearchValue === value) {
            return
        }
        if (this.searchXHR) {
            this.searchXHR.abort()
        }
        this.lastSearchValue = value

        this.$searchSpinner.show()
        this.$searchResultContainer.hide()

        const serializedArray = this.$deliverySearchForm.serializeArray()
        const indexedArray = {}
        // console.log('formData', serializedArray)
        $.map(serializedArray, function (n, i) {
            indexedArray[n['name']] = n['value']
        })

        const ajaxSettings = {
            url: this.searchUrl,
            method: 'POST',
            cache: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(indexedArray),
            headers: {}
        }

        this.searchXHR = $.ajax(ajaxSettings)
            .done(this.handleRequestDone.bind(this))
            .fail(this.handleRequestFail.bind(this))
    }

    handleResponse (status, response) {
        if (status !== 200) {
            return
        }

        this.$searchSpinner.hide()
        this.$searchResultContainer.empty()
        this.$searchResultContainer.html(response.result)
        Behaviors.attachBehaviors(this.$searchResultContainer.get(0))
        this.$searchResultContainer.show()
        this.addNewCustomPharmacyButtonListener()
    }

    handleRequestDone (data, textStatus, jqXHR) {
        this.handleResponse(jqXHR.status, data, jqXHR.responseText)
    }

    handleRequestFail (jqXHR, textStatus, errorThrown) {
        let data = {}
        try {
            if (jqXHR.responseText) {
                data = JSON.parse(jqXHR.responseText)
            }
        } catch (e) {
            console.error(jqXHR.responseText)
        }
        this.handleResponse(jqXHR.status, data, jqXHR.responseText)
    }

    getCurrentDeliverySelection () {
        return this.$deliverySelectForm.find('input[name="combinedDelivery"]:checked').val()
    }

    handleDeliverySelect (event) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()

        const combinedDelivery = this.getCurrentDeliverySelection()
        this.$targetInput.val(combinedDelivery)
        this.$targetInput.trigger('change')
    }

    destroy () {

    }
}
